import { c as _c } from "react/compiler-runtime";
import { MAILING_SETTINGS_API } from 'modules/profile/mailing-settings/api/mailing-settings-api';
import { MailingSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useMailingSettings() {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return MAILING_SETTINGS_API;
      }
      return null;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: mailingData,
    mutate
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== mailingData || $[4] !== mutate) {
    t2 = {
      mailingData,
      mutate
    };
    $[3] = mailingData;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}